
import { defineComponent } from "vue";

export default defineComponent({
  name: "CongestionLevel",
  props: {
    level: {
      type: Number,
      required: true,
    },
  },
  components: {},
});
